export default __webpack_public_path__ + "static/media/235.b539d35f.jpg";